import React from 'react';

/* ----------------------- Contexts ----------------------- */
var FormControllerContext = /*#__PURE__*/React.createContext({});
var FormApiContext = /*#__PURE__*/React.createContext({});
var FormStateContext = /*#__PURE__*/React.createContext({});
var MultistepStepContext = /*#__PURE__*/React.createContext();
var MultistepApiContext = /*#__PURE__*/React.createContext();
var MultistepStateContext = /*#__PURE__*/React.createContext();
var ArrayFieldStateContext = /*#__PURE__*/React.createContext();
var ArrayFieldApiContext = /*#__PURE__*/React.createContext();
var ArrayFieldItemApiContext = /*#__PURE__*/React.createContext();
var ArrayFieldItemStateContext = /*#__PURE__*/React.createContext();
var RelevanceContext = /*#__PURE__*/React.createContext();
var RadioGroupContext = /*#__PURE__*/React.createContext();
var ScopeContext = /*#__PURE__*/React.createContext();
var InformedContext = /*#__PURE__*/React.createContext();

export { ArrayFieldApiContext, ArrayFieldItemApiContext, ArrayFieldItemStateContext, ArrayFieldStateContext, FormApiContext, FormControllerContext, FormStateContext, InformedContext, MultistepApiContext, MultistepStateContext, MultistepStepContext, RadioGroupContext, RelevanceContext, ScopeContext };
